<template>
	<div>
		<a-popover trigger="click" placement="bottomLeft">
			<button
				class="ts-flex ts-items-center ts-bg-blue-100 ts-text-blue-500 ts-px-3 ts-space-x-1 ts-rounded focus:ts-outline-none"
				style="height: 2.2rem;">
				<p>{{ $t('dailyCloseout.groupBy') }}</p>
				<p>{{ groupByDisplay }}</p>
				<i class="fas fa-caret-down"></i>
			</button>
			<template #content>
				<div class="ts-p-1 ts-space-y-1">
					<a-input v-model="search" :placeholder="$t('dailyCloseout.search')" class="ts-mb-2"></a-input>

					<button @click="clearGroupBy"
						class="ts-flex ts-space-x-2 ts-py-1 ts-rounded ts-w-full focus:ts-outline-none ts-duration-200 hover:ts-bg-gray-300 hover:ts-text-red-500"
						style="min-width: 130px;">
						<div class="ts-justify-center ts-items-center ts-flex" style="width: 30px;">
							<i class="fas fa-trash"></i>
						</div>
						<p>{{ $t('dailyCloseout.clearSort') }}</p>
					</button>

					<div v-for="item in columnItems"
						class="ts-py-1 ts-rounded hover:ts-bg-gray-200 hover:ts-text-gray-700 ts-duration-200 ts-px-2 ts-cursor-pointer ts-space-x-2"
						@click.stop="onAddHandler(item)">
						<i :class="iconType(item.type)"></i>
						{{ item.label }}
					</div>
				</div>
			</template>
		</a-popover>
	</div>
</template>

<script>
import { columns } from '../config'

export default {
	name: 'groupBy',
	props: ['value'],
	data() {
		return {
			model: {},
			search: undefined
		}
	},
	created() {
		this.model = this.value
	},
	computed: {
		columnItems() {
			const search = (this.search || '').toLowerCase()
			return columns()
				.map(el => ({
					value: el.key || el.col,
					label: this.$t(`dailyCloseout.${el.label}`),
					type: el.type
				}))
				.filter(item => item.label.toLowerCase().includes(search))
		},
		iconType: () => type => {
			if (type == 'text') {
				return 'fas fa-font'
			}
			if (type == 'date') {
				return 'far fa-clock'
			}
			if (type == 'number') {
				return 'fas fa-dollar-sign'
			}

			return 'fas fa-circle'
		},
		groupByDisplay() {
			const findName = this.columnItems.find(el => el.value === this.model.groupBy)
			if (findName) {
				return findName.label
			}
			return ''
		}
	},
	methods: {
		onAddHandler(item) {
			this.model.groupBy = item.value
		},
		clearGroupBy() {
			this.model.groupBy = undefined
		}
	}
}
</script>